// removed by extract-text-webpack-plugin
module.exports = {"block":"_2hUETOee8sfe-Qt9TbIWp-","content":"_3pzobmS8-8ioDXkPPoRHZy","text":"_3LCDSHzy39waLfID58wgtw","heading":"_1MTn36vTQUEajiLaqPCAjD","intro":"xuXmHWmO0kEPBKzrpOAOE","categories-container":"_1565ullg1CbnHiatJGnY8N","categories-list":"jViIn0pTmVqkWiVhbrDHk","category-button":"_3DhACy7fvjQX1QZGmrmYPE","categories-list-item":"v1ldfOpGxD6t0JKDj2oIK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoriesNavigation/CategoriesNavigation.module.scss
// module id = 739
// module chunks = 0